import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { getAppInfo } from './appInfo';
import { NestEnvelope, RestorePasswordResponse } from '../../types';

type RestorePasswordParams = {
  identificationValue: string;
  phone: string;
  url: string;
};

type ConfirmUsernameParams = {
  username: string;
  url: string;
};

/**
 * Recuperación de contraseña de NestJS, en dos pasos (VWA-37), igual que la
 * app. Las URLs llegan resueltas desde propiedades: antes la Web pedía el Java
 * `v4/recoverypassword`, escrito en el código y solo con el documento.
 */
export const recoveryPasswordApi = createApi({
  reducerPath: 'recoveryPasswordApi',
  baseQuery: fetchBaseQuery(),
  endpoints: builder => ({
    /**
     * Valida documento y línea y responde el usuario que les corresponde. No
     * cambia ninguna contraseña: abre una ventana de 10 minutos para que el
     * vendedor confirme que ese usuario es el suyo.
     */
    restorePassword: builder.mutation<
      RestorePasswordResponse,
      RestorePasswordParams
    >({
      query: ({ identificationValue, phone, url }) => ({
        url,
        method: 'POST',
        body: { identificationValue, phone },
      }),
      transformResponse: (response: NestEnvelope<RestorePasswordResponse>) =>
        response.data,
    }),
    /**
     * Genera la temporal y la envía por el medio configurado. Responde un
     * mensaje que ya dice ese medio («…enviadas a tu correo»), o que no se
     * pudo enviar: es lo que se le muestra al vendedor.
     */
    confirmUsername: builder.mutation<string, ConfirmUsernameParams>({
      query: ({ username, url }) => ({
        url,
        method: 'POST',
        body: { username, appInfo: getAppInfo() },
      }),
      transformResponse: (response: NestEnvelope<undefined>) =>
        response.message,
    }),
  }),
});

export const { useRestorePasswordMutation, useConfirmUsernameMutation } =
  recoveryPasswordApi;
